module.exports = __webpack_public_path__ + "static/media/up-and-to-the-right.c1dd8910.png";